/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Starttime1Inputs */

const en__field_starttime1 = /** @type {(inputs: _Field_Starttime1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start time`)
};

/**
* | output |
* | --- |
* | "Start time" |
*
* @param {_Field_Starttime1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_starttime1 = /** @type {((inputs?: _Field_Starttime1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Starttime1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_starttime1(inputs)
});
export { _field_starttime1 as "_field_startTime" }